import type { ReviewDayCloseInput } from '#shared/types';
import { api } from '#client/lib/api';
import { ENDPOINT } from '#client/lib/endpoints';

/** Marks a submitted Day Close as reconciled, with the reviewer's note. */
export function reviewDayClose(submissionId: number, input: ReviewDayCloseInput): Promise<unknown> {
  return api.patch(ENDPOINT.dayCloseReview(submissionId), input);
}
